export type SortDelta = {
  arr: number[];
  pivot: number;
};

const quickSort = (arr: number[]): SortDelta[] => {
  const _partition = (p: number, q: number): number => {
    const pivot = q;
    let i = p - 1;
    for (let j = p; j <= q; ++j) {
      if (arr[j] > arr[pivot]) continue;
      ++i;
      const temp = arr[i];
      arr[i] = arr[j];
      arr[j] = temp;
    }
    return i;
  };

  const _sort = (start: number, end: number, steps: SortDelta[]): void => {
    if (start >= end) return;
    const pivot = _partition(start, end);
    steps.push({ arr: [...arr], pivot });
    _sort(start, pivot - 1, steps);
    _sort(pivot + 1, end, steps);
  };

  const run = (): SortDelta[] => {
    const steps = [];
    _sort(0, arr.length - 1, steps);
    return steps;
  };

  return run();
};

const Sorting = {
  quick: quickSort,
};

export default Sorting;
